import "core-js/modules/es.array.concat.js";
export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlLogQuery: function smartControlLogQuery(controlId, data) {
      return request({
        url: "/iot/smartControlLog/".concat(controlId, "/query"),
        method: 'get',
        params: data
      });
    },
    smartControlLastRecord: function smartControlLastRecord(controlId) {
      return request({
        url: "/iot/smartControlTLog/".concat(controlId, "/lastRecord"),
        method: 'get'
      });
    },
    smartControlTLogSamplesDays: function smartControlTLogSamplesDays(controlId, startDate, endDate) {
      return request({
        url: "/iot/smartControlTLog/".concat(controlId, "/samples/days/").concat(startDate, "/").concat(endDate),
        method: 'get'
      });
    }
  };
});